import React from 'react';
import {Images,TextArea,Page} from '../index';
import {Btn} from '../../Common/index';
import styled from 'styled-components';
import comic1 from '../../../asset/img/comic/other/comic16_1.png';
import comic2 from '../../../asset/img/comic/other/comic16_2.png';

const H2 = styled.h2`
 font-size: 2em;
 `

const Story13 = () => {
    return(
        <div className="common__item">
        <div className="common__center">
  <H2>筑紫ヒロカドの特技</H2>
  <Images 
  image_1= {comic1}
  image_2= {comic2}
  style3= "display-none"
   alt_1= "筑紫ヒロカドの特技"
   alt_2= "筑紫ヒロカドの特技"

  />
  <TextArea 
   text1="「筑紫広門(ヒロカド)」は非常に「変装」が得意だったそうです。"
   text2="過去、逃走の際にこれをもちいて無事に逃げ切ったとされています。"
   text3="しかし、島津家に幽閉された際は、後で島津義久を激怒させたと残っています。"
   data="2018/10-20"
  />
  <Btn
   text="一覧に戻る"
   link="/comic"
  />
 </div>
 </div>
    )
}
export default Story13;